<template>
<loader v-bind="{ loading }">
  <div class="columns">
    <div class="column">
      <h3 class="title">{{ scraper.scraper.name }}</h3>
      <div>
        {{ scraper.payload }}
      </div>
    </div>
    <div class="column is-narrow">
      <router-link :to="{
        name: 'attribute-type-scraper-create-secondary-scraper',
        params: {
          attributeType: attributeType.id,
          scraper: scraper.id
        }
      }">
        Create Secondary Scraper
      </router-link>
    </div>
  </div>
  <table class="table is-fullwidth">
    <thead>
      <tr>
        <th>Scraper</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="scraper in secondary_scrapers" :key="scraper.id">
        <td>{{ scraper.handler.short_name }}</td>
      </tr>
    </tbody>
  </table>
  <p class="has-text-centered" v-if="!secondary_scrapers.length">
    No Secondary Scrapers available.
  </p>
</loader>
</template>
<script>
import { loadSecondaryScrapersForAttributeScraper, loadAttributeScraper } from '@/api/super'
import { mapGetters } from 'vuex'
export default {
  
  data: () => ({
    loading: true,
    scraper: {
      scraper: {}
    },
    secondary_scrapers: []
  }),

  beforeCreate() {
    Promise.all([
      loadSecondaryScrapersForAttributeScraper(this.$route.params.scraper, ({data}) => this.secondary_scrapers = data),
      loadAttributeScraper(this.$route.params.scraper, ({data}) => this.scraper = data),
    ]).finally(() => this.loading = false)
  },

  computed: {
    ...mapGetters('attributeType', [
      'attributeType'
    ]),
  }

}
</script>